import { useCallback, useMemo } from "react"

import { useGeoServerRetrieveFeature, getFeatureCenterPoint } from "@l2r-front/l2r-geodata"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { ImageTypeSwitch } from "../../components/ImageTypeSwitch"
import { IMAGE_COLLECTION_TYPE_PHOTO, IMAGE_COLLECTION_TYPE_PANO } from "../../constants/imageCollectionsTypes"
import { useImageCollectionStateContext, useImageCollectionDispatchContext } from "../../contexts/ImageCollectionContext"

import { PanoramicViewer } from "../PanoramicViewer/PanoramicViewer"
import { PhotoViewer } from "../PhotoViewer"
import { StreetView } from "../StreetView"

import * as Styled from "./ImageViewer.styled"

export const ImageViewer = (props) => {

    const {
        className,
        bottomRightComponent,
        topRightComponent,
    } = props

    const { imageFeatureClickedPosition, imageCollection, isLoadingImageCollections, triggeringFeatureId, selectedImageCollectionType } = useImageCollectionStateContext()
    const { setSelectedImageCollectionType, isImageCollectionAvailable } = useImageCollectionDispatchContext()
    const isMobile = useIsMobileDevice()
    const {
        data: triggeringFeature,
        isLoading: isLoadingTriggeringFeature,
    } = useGeoServerRetrieveFeature(triggeringFeatureId)

    const initialPosition = useMemo(() => {
        if (imageFeatureClickedPosition) {
            return imageFeatureClickedPosition
        } else if (triggeringFeature) {
            const featureCenter = getFeatureCenterPoint(triggeringFeature)
            return featureCenter.geometry.coordinates
        }

        return null
    }, [imageFeatureClickedPosition, triggeringFeature])

    const onTypeChange = useCallback((type) => {
        setSelectedImageCollectionType(type)
    }, [setSelectedImageCollectionType])

    return (
        <Styled.ImageViewerContainer className={className}>
            <Styled.Container>
                {selectedImageCollectionType === IMAGE_COLLECTION_TYPE_PHOTO ?
                    <PhotoViewer initialPosition={initialPosition} date={imageCollection?.date} />
                    : selectedImageCollectionType === IMAGE_COLLECTION_TYPE_PANO ?
                        <PanoramicViewer initialPosition={initialPosition} date={imageCollection?.date} />
                        : <StreetView initialPosition={initialPosition} />
                }
                {<Styled.TopRightContainer>
                    {topRightComponent}
                    {isImageCollectionAvailable() && <ImageTypeSwitch
                        id="image-type-switch"
                        currentImageCollectionType={selectedImageCollectionType}
                        onChange={onTypeChange}
                        imageCollectionType={imageCollection.type}
                    />}
                </Styled.TopRightContainer>
                }
                {bottomRightComponent && <Styled.BottomRightContainer isMobile={isMobile}>
                    {bottomRightComponent}
                </Styled.BottomRightContainer>}
            </Styled.Container>
            {
                (isLoadingImageCollections || isLoadingTriggeringFeature) &&
                <Styled.LoadingContainer>
                    <Styled.Skeleton />
                </Styled.LoadingContainer>
            }
        </Styled.ImageViewerContainer >
    )
}

ImageViewer.propType = {
    bottomRightComponent: PropTypes.node,
    topLeftComponent: PropTypes.node,
}